import * as React from "react";
import { SxProps, styled, Toolbar as MuiToolbar } from "@mui/material";

interface BannerProps {
  sx?: SxProps;
  children?: React.ReactNode;
  background?: "paper" | "primary";
}

const Banner: React.FC<BannerProps> = ({ background, children, ...otherProps }) => {
  return (
    <Toolbar background={background} {...otherProps}>
      {children}
    </Toolbar>
  );
};

const Toolbar = styled(MuiToolbar)<{ background: BannerProps["background"] }>(({ theme, background }) => ({
  justifyContent: "space-between",
  backgroundColor: background === "primary" ? theme.palette.primary.main : theme.palette.background.paper,
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  minHeight: "48px !important",
  height: "48px !important",
  padding: `0 ${theme.spacing(1)} !important`,
  ...(background === "primary" && {
    ".MuiButton-root, .MuiIconButton-root, .MuiLink-root": {
      //   color: theme.palette.common.white,
    },
  }),
}));

export default Banner;
